import * as types from '../../../actions';

const initialState = {
	vehicleFieldsMasterList:[],
	vehicleFieldsMasterSavedList:[],
  vehicleFieldsMasterStatus: 0,
  vehicleFieldsMasterActivity: '',
  vehicleFieldsMasterErrorData: '',
};

export default function(state = initialState, action) {
  const response = action.data;
  let timeVar = '~~'+Date.now(); 
  switch(action.type) {    

    case types.LIST_VEHICLE_FIELDS_MASTER_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            vehicleFieldsMasterList: action.response.data.results ? action.response.data.results : action.response.data?action.response.data:[],
            vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleFieldsMasterActivity:types.LIST_VEHICLE_FIELDS_MASTER_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          vehicleFieldsMasterList: action.response.data ? action.response.data : [],
          vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleFieldsMasterActivity:types.LIST_VEHICLE_FIELDS_MASTER_ERROR+timeVar,  
        }
      }

    case types.ADD_VEHICLE_FIELDS_MASTER_SUCCESS:
      // IF ALREADY ADDED SKILL RESPONSE IS 200, WE NEED TO CHECK THE MESSAGE IS "already_exist"
            // {"status":409,"message":"already_exist"}
      console.log(action.response.data);       
      if(action.response?.data?.message && action.response.data.message=="already_exist") { 
        return {
            ...state,
            vehicleFieldsMasterErrorData: action.response.data ? action.response.data : [],
            vehicleFieldsMasterStatus: action.response.status,
            vehicleFieldsMasterActivity: types.ADD_VEHICLE_FIELDS_MASTER_ERROR+timeVar, 
        }
      }
      else if(action.response.status && action.response.status===200){
        return {
            ...state, 
            vehicleFieldsMasterSavedList: action.response.data.results ? action.response.data.results : [],
            vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleFieldsMasterActivity:types.ADD_VEHICLE_FIELDS_MASTER_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          vehicleFieldsMasterSavedList: action.response.data ? action.response.data : [],
          vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleFieldsMasterActivity:types.ADD_VEHICLE_FIELDS_MASTER_ERROR+timeVar,  
        }
      }
    
    case types.UPDATE_VEHICLE_FIELDS_MASTER_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            vehicleFieldsMasterSavedList: action.response.data.results ? action.response.data.results : [],
            vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleFieldsMasterActivity:types.UPDATE_VEHICLE_FIELDS_MASTER_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          vehicleFieldsMasterSavedList: action.response.data ? action.response.data : [],
          vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleFieldsMasterActivity:types.UPDATE_VEHICLE_FIELDS_MASTER_ERROR+timeVar,  
        }
      }

    case types.DELETE_VEHICLE_FIELDS_MASTER_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            vehicleFieldsMasterSavedList: action.response.data.results ? action.response.data.results : [],
            vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleFieldsMasterActivity:types.DELETE_VEHICLE_FIELDS_MASTER_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          vehicleFieldsMasterSavedList: action.response.data ? action.response.data : [],
          vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleFieldsMasterActivity:types.DELETE_VEHICLE_FIELDS_MASTER_ERROR+timeVar,  
        }
      }  

    // case types.LIST_VEHICLE_INFO_SUCCESS:
    //  if(action.response.status && action.response.status===200){
    //     return {
    //         ...state, 
    //         vehicleFieldsMasterList: action.response.data.results ? action.response.data.results : action.response.data?action.response.data:[],
    //         vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //         vehicleFieldsMasterActivity:types.LIST_VEHICLE_INFO_SUCCESS+timeVar,  
    //     } 
    //   }
    //   else {
    //     return {
    //       ...state,
    //       vehicleFieldsMasterList: action.response.data ? action.response.data : [],
    //       vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //       vehicleFieldsMasterActivity:types.LIST_VEHICLE_INFO_ERROR+timeVar,  
    //     }
    //   }
    // case types.SAVE_VEHICLE_INFO_SUCCESS:
    //   if(action.response.status && action.response.status===200){
    //     return {
    //         ...state, 
    //         vehicleFieldsMasterSavedList: action.response.data.results ? action.response.data.results : [],
    //         vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //         vehicleFieldsMasterActivity:types.SAVE_VEHICLE_INFO_SUCCESS+timeVar,  
    //     } 
    //   }
    //   else {
    //     return {
    //       ...state,
    //       vehicleFieldsMasterSavedList: action.response.data ? action.response.data : [],
    //       vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //       vehicleFieldsMasterActivity:types.SAVE_VEHICLE_INFO_ERROR+timeVar,  
    //     }
    //   }
    //   case types.UPDATE_VEHICLE_INFO_SUCCESS:
    //     if(action.response.status && action.response.status===200){
    //       return {
    //           ...state, 
    //           vehicleFieldsMasterSavedList: action.response.data.results ? action.response.data.results : [],
    //           vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //           vehicleFieldsMasterActivity:types.UPDATE_VEHICLE_INFO_SUCCESS+timeVar,  
    //       } 
    //     }
    //     else {
    //       return {
    //         ...state,
    //         vehicleFieldsMasterSavedList: action.response.data ? action.response.data : [],
    //         vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //         vehicleFieldsMasterActivity:types.UPDATE_VEHICLE_INFO_ERROR+timeVar,  
    //       }
    //   }
    //   case types.DELETE_VEHICLE_INFO_SUCCESS:
    //     if(action.response.status && action.response.status===200){
    //       return {
    //           ...state, 
    //           vehicleFieldsMasterSavedList: action.response.data.results ? action.response.data.results : [],
    //           vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //           vehicleFieldsMasterActivity:types.DELETE_VEHICLE_INFO_SUCCESS+timeVar,  
    //       } 
    //     }
    //     else {
    //       return {
    //         ...state,
    //         vehicleFieldsMasterSavedList: action.response.data ? action.response.data : [],
    //         vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //         vehicleFieldsMasterActivity:types.DELETE_VEHICLE_INFO_ERROR+timeVar,  
    //       }
    //   }
    //   case types.GET_VEHICLE_INFO_SUCCESS:
    //     if(action.response.status && action.response.status===200){
    //       return {
    //           ...state, 
    //           vehicleFieldsMasterRetrieve: action.response.data ? action.response.data: [],
    //           vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //           vehicleFieldsMasterActivity:types.GET_VEHICLE_INFO_SUCCESS+timeVar,  
    //       } 
    //     }
    //     else {
    //       return {
    //         ...state,
    //         vehicleFieldsMasterRetrieve: action.response.data ? action.response.data : [],
    //         vehicleFieldsMasterStatus: action.response.data.status ? action.response.data.status : '',  
    //         vehicleFieldsMasterActivity:types.GET_VEHICLE_INFO_ERROR+timeVar,  
    //       }
    //   }
    case types.CLEAR:
        return {
            ...state,
            status:0,
            count:'',
            activity:types.CLEAR,
            vehicleFieldsMasterActivity:types.CLEAR,
        }

    default:
      return state;
  }
};